import { CrudOperation } from '@gokrew/models/permissions';

/**
 * Generates a type-safe permission keys map for any portal's Subject enum.
 */
export function createPermissionKeys<S extends string>(
  subjects: S[]
): { [K in S]: { [O in CrudOperation]: `${K}.${O}` } } {
  const keys = {} as Record<string, Record<string, string>>;
  subjects.forEach((subject) => {
    keys[subject] = {};
    Object.values(CrudOperation).forEach((operation) => {
      keys[subject][operation] = `${subject}.${operation}`;
    });
  });
  return keys as { [K in S]: { [O in CrudOperation]: `${K}.${O}` } };
}
